import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Action from '../../../components/actions/Action'
import SitesAction from '../../actions/SitesAction'
import AdministrationAction from '../../../administration/actions/AdministrationAction'
import AppStore from '../../../store/AppStore'
import { connect } from 'react-redux'
import DtoFilterType from '../../../referential/dto/DtoFilterType'
import ThemeDto from '../../../administration/dto/ThemeDto'
import DtoUser from '../../../home/dto/DtoUser'
import i18n from 'simple-react-i18n'
import { filter, flatten } from 'lodash'
import UUID from 'uuid'
import ResearchBarPanel from '../../../research/components/ResearchBarPanel'
import ReferentialAction from '../../../referential/actions/ReferentialAction'
import ToastrAction from '../../../home/actions/ToastrAction'

class ResearchTabPanel extends Component {
	constructor(props) {
		super(props)
	}

	componentWillMount() {
		AppStore.dispatch(AdministrationAction.fetchThemes())
		if (this.props.filterTypes.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchFilterTypes())
		}
	}

	getDefaultTheme = allReferencialThemes => {
		const allThemes = flatten(allReferencialThemes.map(o => o.themes))
		const filterTheme = filter(allThemes, o => !o.disable)
		return filterTheme.map(o => {
			return {
				label: o.title,
				value: o
			}
		})
	}

	componentWillReceiveProps(nexprops) {
		if (!nexprops.selectedThemes.length && nexprops.themes.length) {
			const initDefaultTheme = this.getDefaultTheme(nexprops.themes)
			AppStore.dispatch(AdministrationAction.selectedThemes(initDefaultTheme))
		}
	}

	getDefaultButton = action => {
		if (action) {
			return (
				<a type='submit' data-position='top' data-delay='5' data-tooltip={ i18n.research } name='action'
				   onClick={ () => action() }>
					<i className='material-icons black-text small-research-icon'>search</i>
				</a>
			)
		}
		return (
			<a type='submit' data-position='top' data-delay='5' data-tooltip={ i18n.research } name='action'
			   onClick={ () => action() }>
				<i className='material-icons black-text small-research-icon'>search</i>
			</a>
		)
	}

	getResearchButton = () => {
		if (this.props.selectedFilters.length) {
			if (this.props.selectedThemes.length) {
				return this.getDefaultButton(() => SitesAction.launchResearch(this.props.selectedFilters, this.props.selectedThemes, this.props.filterTypes))
			}
		} else if (this.props.selectedThemes.length) {
			return this.getDefaultButton(() => AppStore.dispatch(ToastrAction.error(i18n.warning.pleaseFillLeastFilter)))
		}
		return this.getDefaultButton(() => AppStore.dispatch(ToastrAction.error(i18n.warning.pleaseFillLeastFilter)))
	}

	getActions = () => {
		return this.props.actions.map(action => (
			<Action key={ UUID.v4() } onClick={ action.fn } icon={ action.icon } component={ action.component }
					title={ action.title }/>
		))
	}

	render() {
		return (
			<div className='research-map col s6 valign-wrapper'>
				<div className='search-content no-padding'>
					<div className='row no-margin valign-wrapper'>
						<div className='col s11 no-padding'>
							<ResearchBarPanel isResearchMap
											  researchClick={ this.researchClick }
											  actions={ this.getResearchButton() }
											  isLogged={ this.props.isLogged }
											  page={ this.props.page }
							/>
						</div>
						<div className='col s1 no-padding'>
							<div className='search-actions'>
								{ this.getActions() }
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

ResearchTabPanel.propTypes = {
	researchType: PropTypes.arrayOf(PropTypes.shape({
		type: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		icon: PropTypes.string.isRequired,
		component: PropTypes.object,
		comment: PropTypes.string
	})),
	user: PropTypes.objectOf(DtoUser),
	isLogged: PropTypes.bool,
	selectedFilters: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.object
	})),
	selectedThemes: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.instanceOf(ThemeDto)
	})),
	themes: PropTypes.arrayOf(PropTypes.instanceOf(ThemeDto)),
	filterTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoFilterType)),
	actions: PropTypes.arrayOf({
		onClick: PropTypes.func.isRequired,
		icon: PropTypes.string,
		title: PropTypes.string,
		component: PropTypes.element
	}),
	page: PropTypes.string
}

const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user,
		selectedFilters: store.AdministrationReducer.selectedFilters,
		filterTypes: store.ReferentialReducer.filterTypes,
		selectedThemes: store.AdministrationReducer.selectedThemes,
		themes: store.AdministrationReducer.themes
	}
}

export default connect(mapStateToProps)(ResearchTabPanel)



// WEBPACK FOOTER //
// ./src/sites/components/research/ResearchTabPanel.js